export const aceCSV: string = `start_date,end_date,max_date,max_speed
2010-01-11 13:00:00,2010-01-12 06:00:00,2010-01-11 15:00:00, 513.0
2010-01-13 06:00:00,2010-01-14 21:00:00,2010-01-14 01:00:00, 519.7
2010-01-20 22:00:00,2010-01-22 05:00:00,2010-01-21 00:00:00, 516.0
2010-01-30 23:00:00,2010-01-31 12:00:00,2010-01-31 07:00:00, 451.4
2010-02-01 07:00:00,2010-02-03 23:00:00,2010-02-03 02:00:00, 565.6
2010-02-18 12:00:00,2010-02-19 14:00:00,2010-02-19 08:00:00, 488.9
2010-03-02 21:00:00,2010-03-04 18:00:00,2010-03-03 13:00:00, 445.4
2010-03-10 09:00:00,2010-03-13 04:00:00,2010-03-12 02:00:00, 557.1
2010-03-16 12:00:00,2010-03-17 20:00:00,2010-03-17 10:00:00, 501.5
2010-03-30 20:00:00,2010-04-06 00:00:00,2010-04-05 13:00:00, 796.2
2010-04-06 02:00:00,2010-04-08 22:00:00,2010-04-07 14:00:00, 629.2
2010-04-14 23:00:00,2010-04-16 09:00:00,2010-04-15 02:00:00, 514.0
2010-05-02 11:00:00,2010-05-07 15:00:00,2010-05-03 12:00:00, 710.6
2010-05-12 03:00:00,2010-05-13 13:00:00,2010-05-12 08:00:00, 489.1
2010-05-19 14:00:00,2010-05-20 21:00:00,2010-05-19 21:00:00, 505.5
2010-05-30 14:00:00,2010-06-05 04:00:00,2010-05-31 15:00:00, 611.1
2010-06-10 05:00:00,2010-06-11 07:00:00,2010-06-10 13:00:00, 461.5
2010-06-15 18:00:00,2010-06-19 00:00:00,2010-06-16 08:00:00, 567.2
2010-06-26 08:00:00,2010-07-05 06:00:00,2010-06-30 10:00:00, 688.0
2010-07-15 00:00:00,2010-07-15 17:00:00,2010-07-15 03:00:00, 470.9
2010-07-25 08:00:00,2010-08-02 17:00:00,2010-07-28 13:00:00, 684.3
2010-08-05 08:00:00,2010-08-06 12:00:00,2010-08-06 00:00:00, 530.5
2010-08-09 06:00:00,2010-08-11 04:00:00,2010-08-11 04:00:00, 478.3
2010-08-13 11:00:00,2010-08-15 02:00:00,2010-08-14 08:00:00, 445.1
2010-08-24 05:00:00,2010-08-29 02:00:00,2010-08-25 08:00:00, 691.2
2010-09-07 07:00:00,2010-09-08 09:00:00,2010-09-07 16:00:00, 487.1
2010-09-09 16:00:00,2010-09-10 19:00:00,2010-09-10 02:00:00, 462.7
2010-09-16 10:00:00,2010-09-18 21:00:00,2010-09-17 07:00:00, 499.9
2010-09-23 17:00:00,2010-09-25 14:00:00,2010-09-25 02:00:00, 634.9
2010-09-26 18:00:00,2010-09-29 11:00:00,2010-09-28 18:00:00, 550.1
2010-10-19 07:00:00,2010-10-20 17:00:00,2010-10-20 11:00:00, 447.3
2010-10-22 19:00:00,2010-10-28 01:00:00,2010-10-24 08:00:00, 669.3
2010-11-11 04:00:00,2010-11-19 12:00:00,2010-11-14 21:00:00, 646.3
2010-11-22 01:00:00,2010-11-23 17:00:00,2010-11-23 02:00:00, 488.3
2010-11-24 03:00:00,2010-11-25 01:00:00,2010-11-25 00:00:00, 472.9
2010-12-12 20:00:00,2010-12-17 20:00:00,2010-12-14 14:00:00, 654.8
2011-01-07 02:00:00,2011-01-17 13:00:00,2011-01-08 14:00:00, 642.7
2011-01-18 22:00:00,2011-01-20 04:00:00,2011-01-19 12:00:00, 522.9
2011-02-01 09:00:00,2011-02-02 17:00:00,2011-02-01 19:00:00, 545.0
2011-02-04 19:00:00,2011-02-07 00:00:00,2011-02-05 05:00:00, 641.4
2011-02-15 05:00:00,2011-02-15 18:00:00,2011-02-15 08:00:00, 503.5
2011-02-18 01:00:00,2011-02-19 02:00:00,2011-02-18 12:00:00, 613.1
2011-02-22 01:00:00,2011-02-22 23:00:00,2011-02-22 04:00:00, 454.4
2011-03-01 15:00:00,2011-03-06 09:00:00,2011-03-02 03:00:00, 673.9
2011-03-11 14:00:00,2011-03-15 09:00:00,2011-03-14 12:00:00, 621.7
2011-03-23 00:00:00,2011-03-25 01:00:00,2011-03-23 14:00:00, 511.6
2011-04-01 15:00:00,2011-04-08 06:00:00,2011-04-02 22:00:00, 656.6
2011-04-11 17:00:00,2011-04-15 03:00:00,2011-04-12 19:00:00, 631.2
2011-04-19 18:00:00,2011-04-22 19:00:00,2011-04-20 12:00:00, 543.3
2011-04-24 09:00:00,2011-04-26 05:00:00,2011-04-25 07:00:00, 565.6
2011-04-29 18:00:00,2011-05-04 20:00:00,2011-05-02 09:00:00, 693.5
2011-05-15 03:00:00,2011-05-18 14:00:00,2011-05-17 09:00:00, 596.1
2011-05-21 10:00:00,2011-05-23 19:00:00,2011-05-23 05:00:00, 458.0
2011-05-27 03:00:00,2011-05-28 04:00:00,2011-05-28 02:00:00, 484.2
2011-05-28 20:00:00,2011-06-02 16:00:00,2011-05-29 11:00:00, 777.5
2011-06-05 01:00:00,2011-06-05 18:00:00,2011-06-05 03:00:00, 549.4
2011-06-08 02:00:00,2011-06-10 12:00:00,2011-06-08 13:00:00, 563.2
2011-06-11 11:00:00,2011-06-17 21:00:00,2011-06-14 15:00:00, 555.8
2011-06-22 05:00:00,2011-06-26 16:00:00,2011-06-23 03:00:00, 662.6
2011-07-09 17:00:00,2011-07-15 00:00:00,2011-07-12 14:00:00, 708.8
2011-07-18 03:00:00,2011-07-24 04:00:00,2011-07-21 05:00:00, 737.6
2011-07-25 00:00:00,2011-07-27 00:00:00,2011-07-25 17:00:00, 588.2
2011-07-30 09:00:00,2011-08-02 18:00:00,2011-07-31 22:00:00, 686.3
2011-08-06 02:00:00,2011-08-06 21:00:00,2011-08-06 05:00:00, 597.5
2011-08-07 19:00:00,2011-08-10 18:00:00,2011-08-09 10:00:00, 626.8
2011-08-14 12:00:00,2011-08-16 15:00:00,2011-08-16 06:00:00, 604.8
2011-08-23 10:00:00,2011-08-24 21:00:00,2011-08-24 01:00:00, 566.8
2011-08-29 15:00:00,2011-08-30 12:00:00,2011-08-29 16:00:00, 492.7
2011-09-09 13:00:00,2011-09-14 08:00:00,2011-09-12 14:00:00, 653.4
2011-09-19 02:00:00,2011-09-20 11:00:00,2011-09-20 01:00:00, 443.7
2011-09-26 13:00:00,2011-10-02 20:00:00,2011-09-26 22:00:00, 677.8
2011-10-15 05:00:00,2011-10-16 09:00:00,2011-10-16 05:00:00, 480.6
2011-10-25 00:00:00,2011-10-27 00:00:00,2011-10-25 19:00:00, 537.7
2011-11-12 05:00:00,2011-11-13 13:00:00,2011-11-12 07:00:00, 462.9
2011-11-15 20:00:00,2011-11-17 11:00:00,2011-11-16 07:00:00, 459.0
2011-11-24 14:00:00,2011-11-25 20:00:00,2011-11-25 06:00:00, 427.9
2011-11-28 21:00:00,2011-12-01 16:00:00,2011-11-28 22:00:00, 511.1
2011-12-10 09:00:00,2011-12-12 21:00:00,2011-12-12 18:00:00, 492.0
2011-12-13 19:00:00,2011-12-14 11:00:00,2011-12-13 22:00:00, 459.6
2012-01-08 20:00:00,2012-01-10 03:00:00,2012-01-09 01:00:00, 442.2
2012-01-10 19:00:00,2012-01-11 22:00:00,2012-01-11 15:00:00, 501.1
2012-01-16 18:00:00,2012-01-17 11:00:00,2012-01-16 18:00:00, 493.6
2012-01-24 23:00:00,2012-01-27 13:00:00,2012-01-25 08:00:00, 619.5
2012-02-02 01:00:00,2012-02-05 11:00:00,2012-02-04 23:00:00, 452.8
2012-02-06 19:00:00,2012-02-08 23:00:00,2012-02-07 20:00:00, 504.4
2012-02-09 05:00:00,2012-02-10 23:00:00,2012-02-10 07:00:00, 454.4
2012-02-19 03:00:00,2012-02-20 22:00:00,2012-02-20 05:00:00, 574.4
2012-02-22 05:00:00,2012-02-26 10:00:00,2012-02-22 15:00:00, 565.7
2012-02-27 07:00:00,2012-02-28 21:00:00,2012-02-27 21:00:00, 499.7
2012-03-01 11:00:00,2012-03-02 02:00:00,2012-03-01 17:00:00, 503.7
2012-03-12 15:00:00,2012-03-20 02:00:00,2012-03-15 18:00:00, 761.0
2012-04-12 09:00:00,2012-04-14 23:00:00,2012-04-13 09:00:00, 644.0
2012-04-17 23:00:00,2012-04-18 23:00:00,2012-04-18 18:00:00, 448.2
2012-04-24 03:00:00,2012-04-26 15:00:00,2012-04-25 22:00:00, 707.5
2012-04-27 21:00:00,2012-04-29 16:00:00,2012-04-28 00:00:00, 468.1
2012-05-08 22:00:00,2012-05-14 03:00:00,2012-05-10 22:00:00, 639.7
2012-05-22 12:00:00,2012-05-25 18:00:00,2012-05-23 06:00:00, 650.1
2012-05-29 18:00:00,2012-05-31 06:00:00,2012-05-30 12:00:00, 455.3
2012-06-04 05:00:00,2012-06-08 10:00:00,2012-06-06 08:00:00, 725.1
2012-06-18 17:00:00,2012-06-19 15:00:00,2012-06-19 01:00:00, 541.8
2012-06-21 22:00:00,2012-06-23 03:00:00,2012-06-22 09:00:00, 442.3
2012-06-26 02:00:00,2012-06-26 15:00:00,2012-06-26 04:00:00, 457.0
2012-06-27 12:00:00,2012-06-29 08:00:00,2012-06-28 00:00:00, 493.4
2012-06-30 10:00:00,2012-07-04 15:00:00,2012-07-01 06:00:00, 668.6
2012-07-10 00:00:00,2012-07-12 00:00:00,2012-07-11 09:00:00, 539.8
2012-07-17 03:00:00,2012-07-19 07:00:00,2012-07-17 11:00:00, 516.1
2012-07-20 07:00:00,2012-07-22 10:00:00,2012-07-21 18:00:00, 513.5
2012-07-23 19:00:00,2012-07-25 14:00:00,2012-07-24 09:00:00, 568.1
2012-07-30 04:00:00,2012-08-01 17:00:00,2012-07-30 14:00:00, 443.4
2012-08-02 18:00:00,2012-08-04 08:00:00,2012-08-03 00:00:00, 473.7
2012-08-13 04:00:00,2012-08-16 13:00:00,2012-08-16 04:00:00, 500.2
2012-08-19 08:00:00,2012-08-21 13:00:00,2012-08-20 04:00:00, 581.2
2012-08-24 22:00:00,2012-08-28 05:00:00,2012-08-27 02:00:00, 673.9
2012-08-28 12:00:00,2012-08-29 19:00:00,2012-08-28 21:00:00, 529.4
2012-09-13 21:00:00,2012-09-14 23:00:00,2012-09-14 12:00:00, 452.8
2012-09-20 02:00:00,2012-09-22 06:00:00,2012-09-20 14:00:00, 577.0
2012-09-26 14:00:00,2012-09-27 15:00:00,2012-09-27 03:00:00, 451.9
2012-10-09 12:00:00,2012-10-11 04:00:00,2012-10-10 00:00:00, 554.9
2012-10-11 14:00:00,2012-10-15 06:00:00,2012-10-13 20:00:00, 576.8
2012-10-17 00:00:00,2012-10-20 02:00:00,2012-10-18 10:00:00, 587.8
2012-11-07 14:00:00,2012-11-08 05:00:00,2012-11-07 16:00:00, 509.5
2012-11-14 07:00:00,2012-11-16 08:00:00,2012-11-15 01:00:00, 476.9
2012-11-20 10:00:00,2012-11-21 06:00:00,2012-11-21 02:00:00, 451.1
2012-11-25 19:00:00,2012-11-26 17:00:00,2012-11-26 05:00:00, 531.2
2012-12-17 03:00:00,2012-12-21 03:00:00,2012-12-17 12:00:00, 500.3
2013-01-13 13:00:00,2013-01-16 00:00:00,2013-01-14 06:00:00, 549.3
2013-01-26 04:00:00,2013-01-27 23:00:00,2013-01-26 23:00:00, 530.3
2013-02-02 00:00:00,2013-02-03 09:00:00,2013-02-02 15:00:00, 494.9
2013-02-08 04:00:00,2013-02-09 03:00:00,2013-02-08 13:00:00, 458.4
2013-03-01 11:00:00,2013-03-03 10:00:00,2013-03-02 05:00:00, 638.4
2013-03-15 08:00:00,2013-03-16 15:00:00,2013-03-16 04:00:00, 478.9
2013-03-17 03:00:00,2013-03-18 08:00:00,2013-03-17 12:00:00, 720.0
2013-03-19 15:00:00,2013-03-21 21:00:00,2013-03-20 17:00:00, 635.3
2013-03-27 14:00:00,2013-03-28 16:00:00,2013-03-27 21:00:00, 537.3
2013-03-29 08:00:00,2013-03-31 16:00:00,2013-03-30 08:00:00, 564.8
2013-04-11 09:00:00,2013-04-12 16:00:00,2013-04-11 19:00:00, 475.7
2013-04-25 03:00:00,2013-04-27 13:00:00,2013-04-26 16:00:00, 580.1
2013-05-01 09:00:00,2013-05-02 21:00:00,2013-05-02 11:00:00, 482.3
2013-05-06 05:00:00,2013-05-08 23:00:00,2013-05-07 17:00:00, 549.6
2013-05-23 17:00:00,2013-05-26 07:00:00,2013-05-25 22:00:00, 765.7
2013-05-26 18:00:00,2013-05-29 16:00:00,2013-05-28 03:00:00, 776.4
2013-06-01 09:00:00,2013-06-05 13:00:00,2013-06-02 12:00:00, 771.0
2013-06-21 17:00:00,2013-06-26 05:00:00,2013-06-23 06:00:00, 698.9
2013-06-30 00:00:00,2013-07-01 07:00:00,2013-07-01 00:00:00, 550.9
2013-07-18 19:00:00,2013-07-20 09:00:00,2013-07-19 13:00:00, 637.8
2013-07-26 02:00:00,2013-07-29 02:00:00,2013-07-26 08:00:00, 570.6
2013-08-04 17:00:00,2013-08-07 22:00:00,2013-08-04 22:00:00, 553.3
2013-08-09 11:00:00,2013-08-11 10:00:00,2013-08-09 22:00:00, 485.9
2013-08-13 18:00:00,2013-08-19 01:00:00,2013-08-16 11:00:00, 774.9
2013-08-21 10:00:00,2013-08-23 23:00:00,2013-08-22 22:00:00, 570.3
2013-08-27 19:00:00,2013-08-28 10:00:00,2013-08-28 04:00:00, 481.7
2013-08-30 20:00:00,2013-09-02 07:00:00,2013-09-01 10:00:00, 562.5
2013-09-03 13:00:00,2013-09-05 08:00:00,2013-09-04 09:00:00, 488.5
2013-09-12 18:00:00,2013-09-14 20:00:00,2013-09-14 00:00:00, 561.4
2013-09-18 14:00:00,2013-09-20 13:00:00,2013-09-18 23:00:00, 558.6
2013-10-02 10:00:00,2013-10-03 00:00:00,2013-10-02 16:00:00, 601.8
2013-10-14 10:00:00,2013-10-16 09:00:00,2013-10-15 18:00:00, 539.8
2013-11-09 06:00:00,2013-11-11 17:00:00,2013-11-09 17:00:00, 612.3
2013-11-30 16:00:00,2013-12-01 08:00:00,2013-12-01 02:00:00, 540.8
2013-12-08 05:00:00,2013-12-09 02:00:00,2013-12-08 14:00:00, 626.4
2013-12-14 21:00:00,2013-12-15 14:00:00,2013-12-15 01:00:00, 585.1
2014-01-01 12:00:00,2014-01-05 11:00:00,2014-01-02 21:00:00, 618.1
2014-01-11 18:00:00,2014-01-15 08:00:00,2014-01-13 07:00:00, 854.0
2014-01-21 20:00:00,2014-01-23 18:00:00,2014-01-22 07:00:00, 589.5
2014-01-28 21:00:00,2014-01-29 22:00:00,2014-01-29 13:00:00, 473.3
2014-02-19 14:00:00,2014-02-21 06:00:00,2014-02-20 04:00:00, 689.6
2014-02-22 07:00:00,2014-02-24 20:00:00,2014-02-24 04:00:00, 560.1
2014-03-04 15:00:00,2014-03-07 17:00:00,2014-03-06 11:00:00, 485.0
2014-03-13 18:00:00,2014-03-15 08:00:00,2014-03-14 05:00:00, 529.3
2014-03-22 07:00:00,2014-03-24 14:00:00,2014-03-22 18:00:00, 512.7
2014-03-31 23:00:00,2014-04-02 10:00:00,2014-04-02 07:00:00, 452.0
2014-04-04 01:00:00,2014-04-05 09:00:00,2014-04-04 08:00:00, 447.4
2014-04-07 18:00:00,2014-04-10 09:00:00,2014-04-09 04:00:00, 479.8
2014-04-18 02:00:00,2014-04-18 23:00:00,2014-04-18 21:00:00, 497.9
2014-04-20 06:00:00,2014-04-21 06:00:00,2014-04-20 11:00:00, 704.8
2014-04-24 00:00:00,2014-04-25 08:00:00,2014-04-24 23:00:00, 482.1
2014-05-23 04:00:00,2014-05-24 06:00:00,2014-05-23 07:00:00, 518.2
2014-06-10 16:00:00,2014-06-12 16:00:00,2014-06-11 10:00:00, 612.3
2014-06-17 19:00:00,2014-06-18 13:00:00,2014-06-17 22:00:00, 461.9
2014-06-20 21:00:00,2014-06-22 04:00:00,2014-06-21 19:00:00, 463.2
2014-07-15 04:00:00,2014-07-16 05:00:00,2014-07-15 20:00:00, 479.0
2014-08-05 08:00:00,2014-08-06 05:00:00,2014-08-05 17:00:00, 476.2
2014-08-10 22:00:00,2014-08-13 09:00:00,2014-08-12 04:00:00, 511.4
2014-08-31 03:00:00,2014-09-01 20:00:00,2014-08-31 21:00:00, 452.3
2014-09-08 05:00:00,2014-09-09 05:00:00,2014-09-09 00:00:00, 441.5
2014-09-19 16:00:00,2014-09-23 08:00:00,2014-09-21 03:00:00, 570.9
2014-09-25 01:00:00,2014-09-26 21:00:00,2014-09-26 12:00:00, 464.1
2014-10-16 07:00:00,2014-10-18 02:00:00,2014-10-18 01:00:00, 462.5
2014-10-19 04:00:00,2014-10-21 23:00:00,2014-10-21 11:00:00, 638.5
2014-10-23 19:00:00,2014-10-24 12:00:00,2014-10-24 01:00:00, 453.8
2014-10-27 14:00:00,2014-10-29 04:00:00,2014-10-28 02:00:00, 429.9
2014-10-31 07:00:00,2014-11-02 12:00:00,2014-11-01 10:00:00, 514.5
2014-11-05 08:00:00,2014-11-06 20:00:00,2014-11-05 19:00:00, 555.4
2014-11-07 23:00:00,2014-11-18 02:00:00,2014-11-16 05:00:00, 641.5
2014-12-01 20:00:00,2014-12-03 08:00:00,2014-12-02 01:00:00, 594.4
2014-12-03 15:00:00,2014-12-05 04:00:00,2014-12-04 13:00:00, 535.0
2014-12-06 16:00:00,2014-12-11 04:00:00,2014-12-07 09:00:00, 745.5
2014-12-12 01:00:00,2014-12-14 19:00:00,2014-12-13 03:00:00, 612.3
2014-12-15 03:00:00,2014-12-17 05:00:00,2014-12-15 19:00:00, 522.9
2014-12-23 12:00:00,2014-12-27 21:00:00,2014-12-24 03:00:00, 558.0
2014-12-29 04:00:00,2015-01-01 11:00:00,2014-12-30 03:00:00, 707.8
2015-01-05 01:00:00,2015-01-06 17:00:00,2015-01-05 15:00:00, 521.0
2015-01-08 06:00:00,2015-01-14 00:00:00,2015-01-11 06:00:00, 565.1
2015-01-21 09:00:00,2015-01-22 23:00:00,2015-01-21 18:00:00, 482.5
2015-01-27 06:00:00,2015-01-28 21:00:00,2015-01-28 03:00:00, 511.9
2015-01-30 09:00:00,2015-02-04 07:00:00,2015-02-02 14:00:00, 708.7
2015-02-06 07:00:00,2015-02-07 13:00:00,2015-02-06 09:00:00, 446.6
2015-02-07 22:00:00,2015-02-09 12:00:00,2015-02-08 14:00:00, 570.5
2015-02-17 22:00:00,2015-02-18 20:00:00,2015-02-18 12:00:00, 462.7
2015-02-24 08:00:00,2015-02-26 11:00:00,2015-02-24 08:00:00, 494.0
2015-03-01 00:00:00,2015-03-03 13:00:00,2015-03-02 10:00:00, 642.1
2015-03-04 12:00:00,2015-03-09 04:00:00,2015-03-07 21:00:00, 577.1
2015-03-17 19:00:00,2015-03-26 05:00:00,2015-03-22 08:00:00, 700.6
2015-04-03 02:00:00,2015-04-06 09:00:00,2015-04-05 21:00:00, 573.2
2015-04-15 19:00:00,2015-04-19 02:00:00,2015-04-17 04:00:00, 716.5
2015-04-21 00:00:00,2015-04-23 23:00:00,2015-04-21 14:00:00, 576.0
2015-05-01 09:00:00,2015-05-03 00:00:00,2015-05-01 17:00:00, 441.9
2015-05-13 07:00:00,2015-05-15 06:00:00,2015-05-14 00:00:00, 740.0
2015-05-19 02:00:00,2015-05-21 10:00:00,2015-05-19 17:00:00, 543.9
2015-06-08 11:00:00,2015-06-11 23:00:00,2015-06-10 14:00:00, 664.5
2015-06-12 20:00:00,2015-06-13 10:00:00,2015-06-12 22:00:00, 525.6
2015-06-14 12:00:00,2015-06-17 08:00:00,2015-06-15 01:00:00, 594.8
2015-06-23 02:00:00,2015-06-29 01:00:00,2015-06-27 05:00:00, 795.3
2015-07-05 02:00:00,2015-07-07 17:00:00,2015-07-05 19:00:00, 543.6
2015-07-11 04:00:00,2015-07-13 16:00:00,2015-07-13 02:00:00, 638.6
2015-07-14 14:00:00,2015-07-17 09:00:00,2015-07-15 05:00:00, 567.5
2015-07-23 02:00:00,2015-07-24 10:00:00,2015-07-23 17:00:00, 490.2
2015-07-25 01:00:00,2015-07-28 19:00:00,2015-07-27 05:00:00, 492.5
2015-07-31 02:00:00,2015-08-04 08:00:00,2015-08-02 11:00:00, 605.3
2015-08-06 07:00:00,2015-08-07 15:00:00,2015-08-06 23:00:00, 566.2
2015-08-08 13:00:00,2015-08-11 12:00:00,2015-08-10 04:00:00, 556.1
2015-08-16 05:00:00,2015-08-18 13:00:00,2015-08-17 12:00:00, 580.1
2015-08-19 05:00:00,2015-08-21 05:00:00,2015-08-20 11:00:00, 518.8
2015-08-23 08:00:00,2015-08-24 07:00:00,2015-08-23 18:00:00, 581.4
2015-08-29 00:00:00,2015-08-30 16:00:00,2015-08-29 12:00:00, 466.7
2015-09-04 02:00:00,2015-09-07 21:00:00,2015-09-07 17:00:00, 600.1
2015-09-11 09:00:00,2015-09-13 03:00:00,2015-09-11 12:00:00, 653.0
2015-09-14 00:00:00,2015-09-17 08:00:00,2015-09-15 08:00:00, 529.9
2015-09-19 23:00:00,2015-09-24 07:00:00,2015-09-22 07:00:00, 653.5
2015-09-24 13:00:00,2015-09-26 05:00:00,2015-09-25 02:00:00, 504.7
2015-10-04 00:00:00,2015-10-05 14:00:00,2015-10-04 14:00:00, 498.7
2015-10-07 19:00:00,2015-10-11 04:00:00,2015-10-07 20:00:00, 775.0
2015-10-12 04:00:00,2015-10-15 05:00:00,2015-10-13 04:00:00, 577.0
2015-10-21 14:00:00,2015-10-22 06:00:00,2015-10-21 18:00:00, 463.0
2015-10-22 22:00:00,2015-10-24 14:00:00,2015-10-23 21:00:00, 461.6
2015-11-03 11:00:00,2015-11-07 12:00:00,2015-11-04 04:00:00, 732.7
2015-11-08 15:00:00,2015-11-12 10:00:00,2015-11-10 15:00:00, 719.3
2015-11-13 19:00:00,2015-11-14 19:00:00,2015-11-14 00:00:00, 471.9
2015-11-30 09:00:00,2015-12-03 10:00:00,2015-12-01 14:00:00, 552.0
2015-12-05 17:00:00,2015-12-09 04:00:00,2015-12-07 13:00:00, 652.5
2015-12-10 05:00:00,2015-12-13 12:00:00,2015-12-11 18:00:00, 661.8
2015-12-14 19:00:00,2015-12-18 15:00:00,2015-12-16 02:00:00, 603.0
2015-12-22 07:00:00,2015-12-27 15:00:00,2015-12-26 20:00:00, 599.1
2016-01-02 13:00:00,2016-01-03 19:00:00,2016-01-03 19:00:00, 482.4
2016-01-05 18:00:00,2016-01-08 19:00:00,2016-01-06 10:00:00, 618.0
2016-01-11 07:00:00,2016-01-14 21:00:00,2016-01-12 07:00:00, 611.8
2016-01-21 06:00:00,2016-01-24 04:00:00,2016-01-23 08:00:00, 568.3
2016-02-04 15:00:00,2016-02-05 21:00:00,2016-02-05 11:00:00, 485.5
2016-02-16 12:00:00,2016-02-20 13:00:00,2016-02-18 05:00:00, 657.9
2016-03-02 08:00:00,2016-03-03 02:00:00,2016-03-02 16:00:00, 470.9
2016-03-06 22:00:00,2016-03-08 08:00:00,2016-03-07 13:00:00, 586.4
2016-03-11 19:00:00,2016-03-13 05:00:00,2016-03-11 20:00:00, 566.8
2016-03-14 22:00:00,2016-03-18 00:00:00,2016-03-17 07:00:00, 586.9
2016-03-19 06:00:00,2016-03-20 13:00:00,2016-03-19 17:00:00, 451.8
2016-03-24 11:00:00,2016-03-25 21:00:00,2016-03-25 07:00:00, 551.4
2016-03-28 01:00:00,2016-03-31 03:00:00,2016-03-29 16:00:00, 547.9
2016-04-02 21:00:00,2016-04-03 14:00:00,2016-04-02 21:00:00, 493.1
2016-04-12 17:00:00,2016-04-14 07:00:00,2016-04-13 06:00:00, 607.0
2016-04-22 05:00:00,2016-04-23 03:00:00,2016-04-22 19:00:00, 587.4
2016-04-23 23:00:00,2016-04-27 08:00:00,2016-04-24 14:00:00, 549.9
2016-05-02 11:00:00,2016-05-04 15:00:00,2016-05-03 05:00:00, 565.4
2016-05-06 21:00:00,2016-05-12 14:00:00,2016-05-09 09:00:00, 679.1
2016-05-15 06:00:00,2016-05-18 22:00:00,2016-05-17 17:00:00, 537.6
2016-05-21 06:00:00,2016-05-24 12:00:00,2016-05-22 04:00:00, 618.4
2016-05-27 22:00:00,2016-06-02 03:00:00,2016-05-30 04:00:00, 537.0
2016-06-05 18:00:00,2016-06-08 12:00:00,2016-06-06 03:00:00, 622.3
2016-06-11 04:00:00,2016-06-12 07:00:00,2016-06-11 16:00:00, 545.6
2016-06-12 22:00:00,2016-06-20 01:00:00,2016-06-15 04:00:00, 690.1
2016-06-23 16:00:00,2016-06-25 08:00:00,2016-06-24 15:00:00, 529.7
2016-06-26 00:00:00,2016-06-28 18:00:00,2016-06-26 15:00:00, 500.8
2016-07-03 08:00:00,2016-07-04 07:00:00,2016-07-03 19:00:00, 468.3
2016-07-07 19:00:00,2016-07-17 03:00:00,2016-07-15 02:00:00, 666.3
2016-07-28 20:00:00,2016-07-30 04:00:00,2016-07-29 08:00:00, 600.6
2016-08-03 03:00:00,2016-08-12 22:00:00,2016-08-05 21:00:00, 683.6
2016-08-23 21:00:00,2016-08-26 16:00:00,2016-08-25 05:00:00, 565.9
2016-09-01 02:00:00,2016-09-08 02:00:00,2016-09-03 16:00:00, 714.2
2016-09-20 06:00:00,2016-09-22 13:00:00,2016-09-20 11:00:00, 725.2
2016-09-27 05:00:00,2016-10-06 02:00:00,2016-09-29 14:00:00, 707.0
2016-10-14 23:00:00,2016-10-19 13:00:00,2016-10-17 11:00:00, 735.3
2016-10-25 14:00:00,2016-10-31 21:00:00,2016-10-25 16:00:00, 727.5
2016-11-11 07:00:00,2016-11-15 21:00:00,2016-11-12 17:00:00, 722.9
2016-11-25 04:00:00,2016-11-28 11:00:00,2016-11-26 09:00:00, 662.8
2016-12-08 06:00:00,2016-12-14 04:00:00,2016-12-09 06:00:00, 702.0
2016-12-21 09:00:00,2016-12-27 20:00:00,2016-12-23 08:00:00, 736.7
2016-12-31 22:00:00,2017-01-01 22:00:00,2016-12-31 22:00:00, 551.5
2017-01-04 00:00:00,2017-01-11 01:00:00,2017-01-07 13:00:00, 713.2
2017-01-18 06:00:00,2017-01-22 04:00:00,2017-01-19 08:00:00, 603.3
2017-01-27 00:00:00,2017-01-28 22:00:00,2017-01-27 10:00:00, 620.2
2017-01-31 00:00:00,2017-02-03 22:00:00,2017-01-31 17:00:00, 763.3
2017-02-05 06:00:00,2017-02-06 14:00:00,2017-02-05 17:00:00, 638.7
2017-02-07 07:00:00,2017-02-07 23:00:00,2017-02-07 08:00:00, 528.9
2017-02-17 07:00:00,2017-02-20 21:00:00,2017-02-19 11:00:00, 571.4
2017-02-23 14:00:00,2017-02-25 04:00:00,2017-02-24 07:00:00, 635.2
2017-03-02 01:00:00,2017-03-09 22:00:00,2017-03-03 10:00:00, 722.6
2017-03-22 06:00:00,2017-03-24 23:00:00,2017-03-22 17:00:00, 677.0
2017-03-27 14:00:00,2017-04-02 02:00:00,2017-03-28 07:00:00, 708.9
2017-04-06 02:00:00,2017-04-07 01:00:00,2017-04-06 13:00:00, 475.0
2017-04-07 17:00:00,2017-04-08 23:00:00,2017-04-08 15:00:00, 591.8
2017-04-20 07:00:00,2017-04-27 21:00:00,2017-04-23 18:00:00, 777.2
2017-05-15 13:00:00,2017-05-17 09:00:00,2017-05-16 05:00:00, 600.7
2017-05-19 12:00:00,2017-05-24 00:00:00,2017-05-20 11:00:00, 723.3
2017-05-30 02:00:00,2017-05-31 08:00:00,2017-05-30 18:00:00, 555.0
2017-06-03 16:00:00,2017-06-04 05:00:00,2017-06-03 19:00:00, 485.0
2017-06-11 23:00:00,2017-06-14 23:00:00,2017-06-12 23:00:00, 525.5
2017-06-17 13:00:00,2017-06-19 12:00:00,2017-06-18 03:00:00, 591.4
2017-06-25 19:00:00,2017-06-27 13:00:00,2017-06-26 22:00:00, 563.3
2017-07-09 12:00:00,2017-07-10 07:00:00,2017-07-10 04:00:00, 630.0
2017-07-17 17:00:00,2017-07-19 03:00:00,2017-07-18 10:00:00, 623.6
2017-07-20 18:00:00,2017-07-26 14:00:00,2017-07-21 11:00:00, 703.3
2017-08-05 03:00:00,2017-08-07 06:00:00,2017-08-05 05:00:00, 694.4
2017-08-11 16:00:00,2017-08-14 12:00:00,2017-08-12 17:00:00, 612.4
2017-08-17 08:00:00,2017-08-21 23:00:00,2017-08-20 04:00:00, 789.3
2017-08-31 12:00:00,2017-09-04 05:00:00,2017-09-01 11:00:00, 653.7
2017-09-04 20:00:00,2017-09-05 16:00:00,2017-09-05 05:00:00, 572.7
2017-09-07 06:00:00,2017-09-08 23:00:00,2017-09-08 07:00:00, 806.4
2017-09-15 01:00:00,2017-09-19 22:00:00,2017-09-16 16:00:00, 704.9
2017-09-27 14:00:00,2017-10-01 19:00:00,2017-09-28 09:00:00, 700.4
2017-10-12 08:00:00,2017-10-13 12:00:00,2017-10-13 12:00:00, 597.5
2017-10-16 07:00:00,2017-10-16 21:00:00,2017-10-16 07:00:00, 551.6
2017-10-25 06:00:00,2017-10-26 10:00:00,2017-10-25 13:00:00, 613.0
2017-11-07 15:00:00,2017-11-11 09:00:00,2017-11-08 00:00:00, 691.0
2017-11-16 05:00:00,2017-11-16 17:00:00,2017-11-16 16:00:00, 493.8
2017-11-21 06:00:00,2017-11-22 16:00:00,2017-11-21 12:00:00, 613.2
2017-12-01 06:00:00,2017-12-01 21:00:00,2017-12-01 10:00:00, 461.3
2017-12-05 06:00:00,2017-12-08 00:00:00,2017-12-05 21:00:00, 613.9
2017-12-12 03:00:00,2017-12-13 05:00:00,2017-12-12 08:00:00, 510.4
2017-12-17 11:00:00,2017-12-19 21:00:00,2017-12-17 15:00:00, 649.8
2018-01-01 06:00:00,2018-01-01 18:00:00,2018-01-01 15:00:00, 468.4
2018-01-14 04:00:00,2018-01-15 23:00:00,2018-01-14 11:00:00, 582.4
2018-01-21 11:00:00,2018-01-22 20:00:00,2018-01-22 08:00:00, 531.2
2018-01-26 06:00:00,2018-01-26 22:00:00,2018-01-26 08:00:00, 493.1
2018-02-17 04:00:00,2018-02-20 01:00:00,2018-02-18 20:00:00, 609.5
2018-02-23 07:00:00,2018-02-24 02:00:00,2018-02-23 12:00:00, 550.4
2018-02-27 08:00:00,2018-02-28 05:00:00,2018-02-27 15:00:00, 548.7
2018-03-15 09:00:00,2018-03-16 03:00:00,2018-03-15 22:00:00, 493.6
2018-03-17 05:00:00,2018-03-19 22:00:00,2018-03-19 06:00:00, 585.2
2018-03-25 16:00:00,2018-03-27 20:00:00,2018-03-27 06:00:00, 539.4
2018-04-09 12:00:00,2018-04-13 01:00:00,2018-04-11 08:00:00, 584.1
2018-04-20 13:00:00,2018-04-22 12:00:00,2018-04-20 16:00:00, 624.4
2018-05-05 14:00:00,2018-05-11 06:00:00,2018-05-08 19:00:00, 665.0
2018-05-12 03:00:00,2018-05-13 00:00:00,2018-05-13 00:00:00, 513.7
2018-05-17 17:00:00,2018-05-18 18:00:00,2018-05-18 16:00:00, 446.1
2018-05-23 05:00:00,2018-05-24 03:00:00,2018-05-23 17:00:00, 519.0
2018-05-31 19:00:00,2018-06-04 20:00:00,2018-06-04 01:00:00, 758.2
2018-06-18 05:00:00,2018-06-20 07:00:00,2018-06-18 20:00:00, 534.5
2018-06-23 12:00:00,2018-06-24 15:00:00,2018-06-23 21:00:00, 487.7
2018-06-26 10:00:00,2018-06-28 07:00:00,2018-06-26 23:00:00, 638.5
2018-07-12 09:00:00,2018-07-14 10:00:00,2018-07-14 01:00:00, 481.8
2018-07-20 05:00:00,2018-07-22 06:00:00,2018-07-21 15:00:00, 557.6
2018-07-24 06:00:00,2018-07-26 23:00:00,2018-07-25 13:00:00, 588.7
2018-08-16 21:00:00,2018-08-18 23:00:00,2018-08-17 21:00:00, 544.4
2018-08-19 21:00:00,2018-08-22 13:00:00,2018-08-20 23:00:00, 657.3
2018-08-26 18:00:00,2018-08-29 16:00:00,2018-08-27 18:00:00, 615.8
2018-09-05 02:00:00,2018-09-05 22:00:00,2018-09-05 12:00:00, 506.3
2018-09-11 06:00:00,2018-09-15 19:00:00,2018-09-14 22:00:00, 681.8
2018-09-17 06:00:00,2018-09-18 22:00:00,2018-09-17 07:00:00, 566.7
2018-09-22 08:00:00,2018-09-22 22:00:00,2018-09-22 17:00:00, 567.9
2018-10-08 00:00:00,2018-10-11 22:00:00,2018-10-09 05:00:00, 631.7
2018-10-14 01:00:00,2018-10-17 02:00:00,2018-10-15 14:00:00, 609.6
2018-11-04 23:00:00,2018-11-07 03:00:00,2018-11-05 05:00:00, 617.8
2018-11-07 07:00:00,2018-11-08 17:00:00,2018-11-08 14:00:00, 498.6
2018-11-09 22:00:00,2018-11-13 14:00:00,2018-11-12 04:00:00, 631.1
2018-12-02 16:00:00,2018-12-03 14:00:00,2018-12-03 14:00:00, 463.1
2018-12-04 15:00:00,2018-12-05 15:00:00,2018-12-04 18:00:00, 471.6
2018-12-07 11:00:00,2018-12-11 23:00:00,2018-12-10 01:00:00, 651.1
2018-12-17 11:00:00,2018-12-21 19:00:00,2018-12-20 09:00:00, 621.6
2018-12-28 05:00:00,2018-12-31 19:00:00,2018-12-28 17:00:00, 600.1
2019-01-05 07:00:00,2019-01-07 15:00:00,2019-01-06 17:00:00, 551.8
2019-01-11 07:00:00,2019-01-12 00:00:00,2019-01-11 07:00:00, 474.9
2019-01-17 11:00:00,2019-01-18 14:00:00,2019-01-17 21:00:00, 495.2
2019-01-24 01:00:00,2019-01-26 22:00:00,2019-01-24 14:00:00, 631.1
2019-01-31 23:00:00,2019-02-03 22:00:00,2019-02-01 09:00:00, 622.9
2019-02-06 10:00:00,2019-02-06 23:00:00,2019-02-06 21:00:00, 451.7
2019-02-08 08:00:00,2019-02-10 17:00:00,2019-02-09 00:00:00, 469.9
2019-02-13 07:00:00,2019-02-15 01:00:00,2019-02-14 07:00:00, 527.7
2019-02-21 12:00:00,2019-02-22 02:00:00,2019-02-21 20:00:00, 461.0
2019-02-28 00:00:00,2019-03-03 00:00:00,2019-03-01 04:00:00, 587.4
2019-03-07 10:00:00,2019-03-08 02:00:00,2019-03-07 13:00:00, 469.0
2019-03-08 23:00:00,2019-03-09 21:00:00,2019-03-09 19:00:00, 455.6
2019-03-28 14:00:00,2019-03-29 18:00:00,2019-03-28 18:00:00, 562.4
2019-04-04 04:00:00,2019-04-06 14:00:00,2019-04-05 19:00:00, 530.9
2019-04-10 01:00:00,2019-04-11 00:00:00,2019-04-10 09:00:00, 463.3
2019-04-11 14:00:00,2019-04-12 20:00:00,2019-04-12 14:00:00, 449.2
2019-04-25 05:00:00,2019-04-26 10:00:00,2019-04-25 10:00:00, 429.7
2019-05-01 16:00:00,2019-05-03 13:00:00,2019-05-02 07:00:00, 570.5
2019-05-04 03:00:00,2019-05-05 05:00:00,2019-05-04 20:00:00, 503.4
2019-05-16 01:00:00,2019-05-16 18:00:00,2019-05-16 16:00:00, 465.8
2019-05-29 01:00:00,2019-05-31 05:00:00,2019-05-29 19:00:00, 561.3
2019-06-13 03:00:00,2019-06-14 14:00:00,2019-06-13 21:00:00, 474.0
2019-07-08 23:00:00,2019-07-15 23:00:00,2019-07-10 09:00:00, 642.9
2019-07-30 21:00:00,2019-08-02 05:00:00,2019-08-01 05:00:00, 557.4
2019-08-05 10:00:00,2019-08-11 01:00:00,2019-08-06 03:00:00, 717.1
2019-08-13 13:00:00,2019-08-14 19:00:00,2019-08-13 18:00:00, 479.9
2019-08-27 16:00:00,2019-08-28 18:00:00,2019-08-28 07:00:00, 501.3
2019-08-30 14:00:00,2019-09-11 12:00:00,2019-09-01 01:00:00, 751.5
2019-09-13 00:00:00,2019-09-14 07:00:00,2019-09-13 18:00:00, 496.0
2019-09-24 20:00:00,2019-09-25 08:00:00,2019-09-24 23:00:00, 495.6
2019-09-27 12:00:00,2019-10-03 17:00:00,2019-09-27 23:00:00, 697.2
2019-10-10 02:00:00,2019-10-12 01:00:00,2019-10-10 20:00:00, 494.7
2019-10-24 10:00:00,2019-10-28 11:00:00,2019-10-26 17:00:00, 654.5
2019-11-21 06:00:00,2019-11-25 05:00:00,2019-11-21 20:00:00, 598.6
2019-11-25 09:00:00,2019-11-25 22:00:00,2019-11-25 20:00:00, 456.7
2019-12-18 09:00:00,2019-12-19 23:00:00,2019-12-19 11:00:00, 533.9
2020-01-05 17:00:00,2020-01-07 00:00:00,2020-01-05 23:00:00, 538.0
2020-01-08 22:00:00,2020-01-12 13:00:00,2020-01-10 03:00:00, 550.4
2020-01-29 03:00:00,2020-01-30 02:00:00,2020-01-29 06:00:00, 455.9
2020-01-30 09:00:00,2020-02-02 16:00:00,2020-01-31 09:00:00, 512.7
2020-02-06 13:00:00,2020-02-08 23:00:00,2020-02-07 02:00:00, 639.3
2020-02-21 04:00:00,2020-02-22 20:00:00,2020-02-22 08:00:00, 500.5
2020-02-28 23:00:00,2020-03-02 04:00:00,2020-02-29 20:00:00, 540.3
2020-03-02 09:00:00,2020-03-04 00:00:00,2020-03-02 13:00:00, 460.0
2020-03-20 17:00:00,2020-03-22 02:00:00,2020-03-21 10:00:00, 522.6
2020-03-23 05:00:00,2020-03-24 22:00:00,2020-03-23 11:00:00, 518.2
2020-03-30 12:00:00,2020-04-01 13:00:00,2020-03-31 14:00:00, 537.0
2020-04-02 11:00:00,2020-04-04 21:00:00,2020-04-03 12:00:00, 458.3
2020-04-08 14:00:00,2020-04-09 09:00:00,2020-04-08 18:00:00, 492.8
2020-04-11 17:00:00,2020-04-12 14:00:00,2020-04-12 06:00:00, 453.8
2020-04-14 20:00:00,2020-04-15 22:00:00,2020-04-15 06:00:00, 432.3
2020-04-21 16:00:00,2020-04-22 17:00:00,2020-04-22 01:00:00, 473.4
2020-06-07 20:00:00,2020-06-08 14:00:00,2020-06-08 03:00:00, 470.7
2020-06-09 18:00:00,2020-06-12 00:00:00,2020-06-10 11:00:00, 477.0
2020-07-04 19:00:00,2020-07-07 07:00:00,2020-07-06 02:00:00, 521.5
2020-08-02 13:00:00,2020-08-08 09:00:00,2020-08-04 01:00:00, 690.7
2020-08-26 06:00:00,2020-09-01 14:00:00,2020-09-01 14:00:00, 636.7
2020-09-02 09:00:00,2020-09-03 08:00:00,2020-09-02 15:00:00, 517.2
2020-09-24 02:00:00,2020-10-02 21:00:00,2020-10-01 01:00:00, 670.7
2020-10-23 17:00:00,2020-10-29 05:00:00,2020-10-27 04:00:00, 611.2
2020-11-06 04:00:00,2020-11-08 03:00:00,2020-11-07 08:00:00, 496.4
2020-11-22 03:00:00,2020-11-24 00:00:00,2020-11-22 16:00:00, 627.8
`;